import type { DataErrorRepository } from '../data/data-error-repository';
import type { IrregularDeltaItem } from '../types/data-error-types';

export class UpdateDeltaCommentUseCase {
  constructor(private readonly repository: DataErrorRepository) {}

  async execute(
    irregularId: number,
    comment: string | null
  ): Promise<
    { isSuccess: true; updatedItem: IrregularDeltaItem | null } |
    { isSuccess: false; errorMessage: string }
  > {
    try {
      const updatedItem = await this.repository.updateComment({ irregularId, comment });
      return { isSuccess: true, updatedItem };
    } catch (error: unknown) {
      return {
        isSuccess: false,
        errorMessage: error instanceof Error ? error.message : 'Failed to update comment',
      };
    }
  }
}
